export default __webpack_public_path__ + "static/media/wallet-empty.57285bfa.svg";